import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiAuthService } from '../services/api-auth.service';
import { Globals } from '../globals';
import { Proveedor } from 'src/app/models/Proveedor';

@Injectable({
  providedIn: 'root'
})
export class CanMenuPerfilGuard implements CanActivate {
  
  constructor(private apiAuth: ApiAuthService, private router: Router, public globals: Globals){}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      let proveedor: Proveedor = this.apiAuth.getTokenDecoded();
      if (this.apiAuth.getToken() != null) {
            return true;
      } else {
          this.router.navigate(['/home']);
      }
  }

}
